var cov_23hhydjcgc = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Datum/types.ts",
      hash = "4fa4d2e60ceab4671fe6042341f6d8798012e174",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Datum/types.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 31
        },
        end: {
          line: 2,
          column: 79
        }
      },
      "1": {
        start: {
          line: 2,
          column: 49
        },
        end: {
          line: 2,
          column: 79
        }
      },
      "2": {
        start: {
          line: 5,
          column: 30
        },
        end: {
          line: 5,
          column: 77
        }
      },
      "3": {
        start: {
          line: 5,
          column: 48
        },
        end: {
          line: 5,
          column: 77
        }
      },
      "4": {
        start: {
          line: 8,
          column: 31
        },
        end: {
          line: 8,
          column: 79
        }
      },
      "5": {
        start: {
          line: 8,
          column: 49
        },
        end: {
          line: 8,
          column: 79
        }
      },
      "6": {
        start: {
          line: 10,
          column: 28
        },
        end: {
          line: 10,
          column: 46
        }
      },
      "7": {
        start: {
          line: 12,
          column: 30
        },
        end: {
          line: 12,
          column: 50
        }
      },
      "8": {
        start: {
          line: 14,
          column: 27
        },
        end: {
          line: 14,
          column: 44
        }
      },
      "9": {
        start: {
          line: 16,
          column: 26
        },
        end: {
          line: 16,
          column: 51
        }
      },
      "10": {
        start: {
          line: 18,
          column: 31
        },
        end: {
          line: 18,
          column: 52
        }
      },
      "11": {
        start: {
          line: 20,
          column: 26
        },
        end: {
          line: 20,
          column: 49
        }
      },
      "12": {
        start: {
          line: 22,
          column: 28
        },
        end: {
          line: 22,
          column: 51
        }
      },
      "13": {
        start: {
          line: 24,
          column: 33
        },
        end: {
          line: 24,
          column: 56
        }
      },
      "14": {
        start: {
          line: 26,
          column: 27
        },
        end: {
          line: 26,
          column: 44
        }
      },
      "15": {
        start: {
          line: 28,
          column: 28
        },
        end: {
          line: 28,
          column: 46
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 31
          },
          end: {
            line: 2,
            column: 32
          }
        },
        loc: {
          start: {
            line: 2,
            column: 49
          },
          end: {
            line: 2,
            column: 79
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 5,
            column: 30
          },
          end: {
            line: 5,
            column: 31
          }
        },
        loc: {
          start: {
            line: 5,
            column: 48
          },
          end: {
            line: 5,
            column: 77
          }
        },
        line: 5
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 8,
            column: 31
          },
          end: {
            line: 8,
            column: 32
          }
        },
        loc: {
          start: {
            line: 8,
            column: 49
          },
          end: {
            line: 8,
            column: 79
          }
        },
        line: 8
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_23hhydjcgc.s[0]++;
// FLow chagne
export var changeSubscribe = function changeSubscribe(name) {
  cov_23hhydjcgc.f[0]++;
  cov_23hhydjcgc.s[1]++;
  return "__CHANGE_SUBSCRIBE_".concat(name, "__");
}; // setError

cov_23hhydjcgc.s[2]++;
export var errorSubscribe = function errorSubscribe(name) {
  cov_23hhydjcgc.f[1]++;
  cov_23hhydjcgc.s[3]++;
  return "__ERROR_SUBSCRIBE_".concat(name, "__");
}; // value chagne

cov_23hhydjcgc.s[4]++;
export var updateSubscribe = function updateSubscribe(name) {
  cov_23hhydjcgc.f[2]++;
  cov_23hhydjcgc.s[5]++;
  return "__UPDATE_SUBSCRIBE_".concat(name, "__");
};
export var CHANGE_TOPIC = (cov_23hhydjcgc.s[6]++, '__CHANGE_TOPIC__');
export var VALIDATE_TOPIC = (cov_23hhydjcgc.s[7]++, '__VALIDATE_TOPIC__');
export var RESET_TOPIC = (cov_23hhydjcgc.s[8]++, '__RESET_TOPIC__');
export var FORCE_PASS = (cov_23hhydjcgc.s[9]++, '__VALIDATE_FORCE_PASS__');
export var IGNORE_VALIDATE = (cov_23hhydjcgc.s[10]++, '__IGNORE_VALIDATE__');
export var ERROR_TYPE = (cov_23hhydjcgc.s[11]++, '__UPDATE_ERROR_TYPE__');
export var REMOVE_ERROR = (cov_23hhydjcgc.s[12]++, '__REMOVE_ERROR_TYPE__');
export var WITH_OUT_DISPATCH = (cov_23hhydjcgc.s[13]++, '__WITH_OUT_DISPATCH__');
export var IGNORE_BIND = (cov_23hhydjcgc.s[14]++, '__IGNORE_BIND__');
export var SUBMIT_TOPIC = (cov_23hhydjcgc.s[15]++, '__SUBMIT_TOPIC__');